<template>
  <b-modal ref="changeCompanyModal" hide-footer :title="`Remplacer ${company.name} par`">
    <b-form @submit.prevent="performChangeCompany">
      <b-form-group label="Chercher une société">
        <b-form-input
          v-model="companySearchQuery"
          type="text"
          placeholder="Saisissez pour rechercher..."
          @input="fetchCompanySuggestions"
        ></b-form-input>
        <b-list-group v-if="companySuggestions.length > 0">
          <b-list-group-item
            v-for="(company, index) in companySuggestions"
            :key="company.id"
            @click="selectCompany(company)"
          >
            {{ company.name }} ({{ company.zip }} {{ company.city }})
          </b-list-group-item>
        </b-list-group>
      </b-form-group>

      <b-button variant="primary" type="submit">Changer</b-button>
      <b-button variant="secondary" @click="hideChangeCompanyDialog">Annuler</b-button>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      company: { },
      account: { },
      companySearchQuery: '',
      companySuggestions: [],
      selectedCompany : null
    };
  },
  methods: {
    init(company, account) {
        this.company = company
        this.account = account
    },

    async fetchCompanySuggestions(query) {
          
          if (query) {
            try {
              let response = await this.$http.get(`/admin/searchcompanies?host=false&limit=10&q=${query}`);
              this.companySuggestions = response.data.result;  // assuming response.data is an array of company names
            } catch (error) {
              console.error("Error fetching company suggestions:", error);
              swal("Erreur", `Erreur dans la recherche : ${error}`);
            }
          }
        },

    selectCompany(company) {
      // Update the selected company
      this.selectedCompany = company;
      // Update the search input with the selected company's name
      this.companySearchQuery = `${company.name} (${company.zip} ${company.city})`;
      // Clear suggestions after selection
      this.companySuggestions = [];
    },
    async performChangeCompany() {
          if (this.selectedCompany) {
            try {
              let response = await this.$http.post(`/admin/changecompany`, {accountid:this.account.id, companyid: this.selectedCompany.id });
              await swal("Succès", `La fiche signalétique a été changée par la société ${this.selectedCompany.name}`, "success");
              this.hideChangeCompanyDialog();
              this.$router.go(0);
            } catch (error) {
              swal("Erreur", `Ne peut pas changer la fiche signalétique. ${error.response ? error.response.data : error.message}`, "error");
            }
          } else {
            swal("Erreur", "No company selected", "error");
          }
        },

    hideChangeCompanyDialog() {
      // Logic to hide the modal
      this.$refs.changeCompanyModal.hide();
    },
    showChangeCompanyDialog() {
      this.$refs.changeCompanyModal.show();
    },
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>

